import { colors, s4 } from '@ardoq/design-tokens';
import styled from 'styled-components';
import {
  DragAndDropCardWrapper,
  DragAndDropSectionProps,
} from '@ardoq/drag-and-drop';
import { DRAG_BUTTON_CLASS_NAME } from '@ardoq/icons';
import { ColorBar, IslandHeader, IslandHeaderProps } from './IslandHeader';

const IslandDragAndDropCardWrapper = styled(DragAndDropCardWrapper)`
  flex: 1;
  align-items: center;
  width: 100%;
  .${DRAG_BUTTON_CLASS_NAME} {
    padding-left: ${s4};
  }
`;

const BorderWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid ${colors.borderAction};
  &:only-child {
    border-bottom: 0;
  }
`;

export const DragAndDropIslandHeader = ({
  barColor,
  dragAndDropCardId,
  ...headerProps
}: IslandHeaderProps & DragAndDropSectionProps) => (
  <BorderWrapper>
    {barColor && <ColorBar $barColor={barColor} />}
    <IslandDragAndDropCardWrapper
      dragAndDropCardId={dragAndDropCardId}
      dragButtonAlwaysVisible
      dragButtonPosition="left"
    >
      <IslandHeader {...headerProps} />
    </IslandDragAndDropCardWrapper>
  </BorderWrapper>
);
